module.exports = __webpack_public_path__ + "static/img/einzelstuecke.094f896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat/einzelstuecke.png
// module id = RsF+
// module chunks = 1